import type { GenericTrackingEvent } from '@packages/tracking';
import { useMouseflow, useTracking } from '@packages/tracking';

import type { NavigationItem } from './navigationTypes';

/**
 * Provides a function to track navigation events.
 *
 * Returned event handlers should be called every time the respective event occurs.
 */
export const useNavigationTracking = () => {
  const pushMouseflowData = useMouseflow();
  const dispatchGTMEvent = useTracking();

  const onNavigate = (item: NavigationItem) => {
    pushMouseflowData('search_Navi');

    const pathSegments = item?.uri?.split('/').filter((segment) => segment);

    dispatchGTMEvent<GenericTrackingEvent>({
      event: 'Layer_Navi',
      eventValue: pathSegments,
    });
  };

  return { onNavigate };
};
